// import React, { useEffect } from 'react';
// import './ConferenceSchedule.css';
// import Navbar from './Navbar';
// import Footer from './Footer';

// const ConferenceSchedule = () => {
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   }, []);

//   return (
//     <>
//         <Navbar />
//     <div className="conference-schedule-container">
//       <div className="schedule-box">
//         <h1 className="schedule-heading">Conference Schedule</h1>
//         <p className="schedule-message">
//           The detailed conference schedule is currently being finalized.<br />
//           Please stay tuned — it will be published closer to the event.
//         </p>
//         <p className="schedule-note">We appreciate your patience and enthusiasm!</p>
//       </div>
//     </div>
//     <br />
//     <br />
//     <Footer />
//     </>
//   );
// };

// export default ConferenceSchedule;

import React, { useEffect, useState } from 'react';
import './ConferenceSchedule.css';
import Navbar from './Navbar';
import Footer from './Footer';

const ConferenceSchedule = () => {
  const [showInlineViewer, setShowInlineViewer] = useState(true);
  const pdfUrl = '/stis2025/assets/schd.pdf';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Navbar />

      {/* ✅ Heading OUTSIDE the container */}
      <div className="schedule-page-heading">
        Tentative STIS-V 2025 Schedule
      </div>

      <div className="conference-schedule-container">
        <div className="schedule-box">

          <div className="schedule-actions">
            <a className="btn btn-primary" href={pdfUrl} download>
              Download PDF
            </a>

            <a className="btn btn-secondary" href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Open in new tab
            </a>

            <button className="btn btn-outline" onClick={() => setShowInlineViewer(v => !v)}>
              {showInlineViewer ? 'Hide inline view' : 'Show inline view'}
            </button>
          </div>

          {showInlineViewer && (
            <div className="pdf-viewer-wrap">
              <iframe
                title="Tentative STIS-V 2025 Schedule"
                src={`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                className="pdf-iframe"
              />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ConferenceSchedule;
